import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Typography,
  MenuItem
} from "@mui/material";
import { authenticationService } from "src/services";
import { get, post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

interface AddAreaProps {
  handleClose: () => void;
  fetchAreas: () => void;
}
interface CityDropdown {
  id: number;
  city: string;
}
const AddArea: React.FC<AddAreaProps> = ({
  handleClose,
  fetchAreas
}) => {
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { showSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [cities, setCitiesList] = useState<CityDropdown[]>([]);

  const [form, setForm] = useState({
    name: "",
    cityId: "",
    zipCode: "",
    isActive: true,
    vendorId: vendorId
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  /* =========================
     Fetch Cities (GET)
  ========================= */
  const fetchCities = async () => {
    try {
      const response = await get(`${APIURL}/api/miscellaneous/city/vendor/${vendorId}/findAll`);
      console.log('response',response)
      if (response) setCitiesList(response?.data);
    } catch (error) {
      console.error("Error fetching states", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  const handleSubmit = async () => {
    if (!form.name ) {
      showSnackbar("Area name  required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        id: 0,
        name: form.name,
        cityId: form.cityId || "",
        zipCode: form.zipCode,
        isActive: form.isActive,
        vendorId: form.vendorId
      };

      const response = await post(
        `${APIURL}/api/miscellaneous/area`,
        payload
      );

      if (response?.statusCode === 200) {
        showSnackbar(response?.message || "Area added successfully", "success");
        fetchAreas();
        handleClose();
      } else {
        showSnackbar(response?.message || "Failed to add area", "error");
      }
    } catch (error: any) {
      showSnackbar(error?.message || "Failed to add area", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Add Area
      </Typography>

      <Grid container spacing={2}>
        {/* City Dropdown */}
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            required
            label="City"
            name="cityId"
            value={form.cityId}
            onChange={handleChange}
          >
            {cities.map(city => (
              <MenuItem key={city.id} value={city.id}>
                {city.city}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Area Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>

        

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={e =>
                  setForm(prev => ({
                    ...prev,
                    isActive: e.target.checked
                  }))
                }
              />
            }
            label="Is Active"
          />
        </Grid>

        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddArea;
